import React, { useState } from "react";
import { withStyles } from "@material-ui/core";
import { observer } from "mobx-react-lite";
import moment from "moment";
import styles from "./ModalBloquear/ModalBloquearStyles";
import { InputDateForm } from "../../components/Modal/Input";
import { ReactSelect } from "../../components/Select/SelectSearch";
import ModalConfirmacao from "../../components/Modal/ModalConfirmacao/ModalConfirmacao";
import UndoIcon from "../../components/Icon/UndoIcon";
import { findAllProfissionalSaudeComAgenda } from "../../services/ProfissionalSaudeService";
import { inject } from "mobx-react";
import { TextFieldSearch } from "../../components/TextField";

const iconProps = {
  size: 24,
  color: "#FFF",
};

const acaoOptions = [
  { value: "BLOQUEAR", label: "Bloquear" },
  { value: "LIBERAR", label: "Liberar" },
];

const ModalDesfazerModificacao = observer(
  ({ filtroHeaderStore, classes, open, close, handleConfirm, isLoading }) => {
    const profissionalAgenda = filtroHeaderStore.profissionalSaude;

    const [dataInicio, setDataInicio] = useState(moment().format("YYYY-MM-DD"));
    const [dataFim, setDataFim] = useState(moment().format("YYYY-MM-DD"));
    const [profissionalSaude, setProfissionalSaude] = useState(
      profissionalAgenda
    );
    const [acao, setAcao] = useState(null);

    const loadProfissionalSaude = async (search, loadedOptions, { page }) => {
      const response = await findAllProfissionalSaudeComAgenda({
        search,
        ativo: true,
        pageableDTO: {
          sortDir: "ASC",
          sortField: "nome",
          pageNumber: page,
          pageSize: 20,
        },
      });

      const { content, last } = response;

      if (content) {
        return {
          options: content,
          hasMore: !last,
          additional: {
            page: page + 1,
          },
        };
      }
    };

    const confirmaDesfazer = () => {
      const variables = {
        dataInicio: moment(dataInicio).format("YYYY-MM-DD"),
        dataFim: moment(dataFim).format("YYYY-MM-DD"),
        idProfissionalSaude: profissionalSaude?.id,
        acao: acao?.value,
      };
      handleConfirm(variables);
    };

    const checkDisabledButton = () => {
      return (
        !dataInicio || !dataFim || !profissionalSaude || !acao || isLoading
      );
    };

    return (
      <ModalConfirmacao
        open={open}
        icon={<UndoIcon {...iconProps} />}
        color={"#E4595B"}
        title="Desfazer Modificação"
        classes={{
          paperAlert: classes.paperAlert,
        }}
        buttons={{
          labelPrimaryButton: "Cancelar",
          handlePrimaryButton: () => close(),
          disabledPrimaryButton: isLoading,
          idPrimaryButton: "agd-mdm-btn-cnc",
          labelSecondButton: "Salvar",
          handleSecondButton: () => confirmaDesfazer(),
          disabledSecondButton: checkDisabledButton(),
          loadingSecondButton: isLoading,
          idSecondButton: "agd-mdm-btn-slv",
        }}
      >
        <div className={classes.content}>
          <div className={classes.inputWithLabelContainer}>
            <div className={classes.title}>Data Início</div>
            <InputDateForm
              id="agd-mdm-inp-ini"
              iconposition="end"
              className={classes.dateTime}
              classes={{
                date: classes.inputDate,
              }}
              value={dataInicio}
              onChange={(e) => setDataInicio(e)}
            />
          </div>

          <div className={classes.inputWithLabelContainer}>
            <div className={classes.title}>Data Fim</div>
            <InputDateForm
              id="agd-mdm-inp-fim"
              iconposition="end"
              className={classes.dateTime}
              classes={{
                date: classes.inputDate,
              }}
              value={dataFim}
              onChange={(e) => setDataFim(e)}
            />
          </div>

          <div className={classes.inputWithLabelContainer}>
            <div className={classes.title}>Profissional Saúde</div>
            <TextFieldSearch
              id="agd-mdm-sel-prf"
              placeholder="Profissional"
              loadOptions={loadProfissionalSaude}
              withPaginate
              value={profissionalSaude}
              getOptionLabel={(option) => option.nome}
              getOptionValue={(option) => option.id}
              onChange={(e) => setProfissionalSaude(e)}
              debounceTimeout={300}
              additional={{
                page: 0,
              }}
            />
          </div>

          <div className={classes.inputWithLabelContainer}>
            <div className={classes.title}>Ação</div>
            <ReactSelect
              id="agd-mdm-sel-aca"
              className={classes.selectSearch}
              placeholder="Selecione"
              value={acao}
              options={acaoOptions}
              getOptionLabel={(option) => option.label}
              getOptionValue={(option) => option.value}
              onChange={setAcao}
              isClearable
            />
          </div>
        </div>
      </ModalConfirmacao>
    );
  }
);

const ModalDesfazerModificacaoWithStyles = withStyles(styles)(
  ModalDesfazerModificacao
);
export default inject("filtroHeaderStore")(ModalDesfazerModificacaoWithStyles);
